<template>
  <el-dialog title="关闭线索" :visible.sync="visible" width="30%">
    <p>确认关闭线索？关闭后可再次恢复打开。</p>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { closeClue } from "@/api/crm/clue";

export default {
  name: "CloseClueDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      clueId: null,
      informantName: ""
    };
  },
  created() {
  },
  components: {
  },
  watch: {
  },
  methods: {
    open (clueId, informantName) {
      if (!clueId) {
        this.msgError("没有选中任何记录")
        return
      }
      this.clueId = clueId
      this.informantName = informantName
      this.visible = true
    },
    confirm () {
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading'
      });
      closeClue({id: this.clueId}).then(response => {
        this.$emit('success')
        this.visible = false
        loading.close();
        this.msgSuccess("线索关闭成功");
      }).catch(error => {
        loading.close()
      })
    }
  }
};
</script>
